
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { postProjectGroup, patchProjectGroup } from '@/utils/project'
import ProjectsAutocomplete from '@/components/Autocomplete/projects.vue'

@Component({
    inheritAttrs: false,
    name: 'ProjectGroupForm',
    components: { ProjectsAutocomplete },
})
export default class ProjectGroupForm extends Vue {
    @Prop({ required: false }) projectGroup!: Record<string, any> | null
    @Prop({ required: false }) cloneProjectGroup!: Record<string, any> | null

    isValid = false
    isLoading = false

    projectGroupBase = {
        name: '',
        owners: {
            data: [],
        },
        projects: {
            data: [],
        },
        companies: {
            data: [],
        },
        sharedWith: {
            data: [],
        },
    }

    projectGroupInput = null as null | Record<string, any>

    initiateProjectGroupForm() {
        this.projectGroupInput = this.lodash.cloneDeep(this.projectGroupBase)

        if (this.projectGroup) {
            Object.keys(this.projectGroupInput).map((key) => {
                if (this.projectGroup && this.projectGroupInput)
                    this.projectGroupInput[key] = this.lodash.cloneDeep(this.projectGroup[key])
            })
        } else if (this.cloneProjectGroup) {
            Object.keys(this.projectGroupInput).map((key) => {
                if (this.cloneProjectGroup && this.projectGroupInput)
                    this.projectGroupInput[key] = this.lodash.cloneDeep(this.cloneProjectGroup[key])
            })
        }
    }

    async updateProjectGroup() {
        try {
            this.isLoading = true
            return await patchProjectGroup({ id: this.projectGroup?.id, ...this.projectGroupInput })
        } catch (error) {
            this.$store.commit('setGeneralErrorSnackBar', error)
        } finally {
            this.isLoading = false
        }
    }

    async createProjectGroup() {
        try {
            this.isLoading = true
            delete this.projectGroupInput?.owners
            return await postProjectGroup(this.projectGroupInput)
        } catch (error) {
            this.$store.commit('setGeneralErrorSnackBar', error)
        } finally {
            this.isLoading = false
        }
    }

    async submit() {
        if (this.isValid) {
            if (this.projectGroup) {
                return await this.updateProjectGroup()
            } else {
                return await this.createProjectGroup()
            }
        }
    }

    @Watch('isValid')
    updateIsValid() {
        this.$emit('update:isValid', this.isValid)
    }

    @Watch('isLoading')
    updateIsLoading() {
        this.$emit('update:isLoading', this.isValid)
    }

    mounted() {
        this.initiateProjectGroupForm()
    }
}
